export default "__VITE_ASSET__CRA3$jSh__"